import axios from "axios"
import moment from "moment"

const url = process.env.REACT_APP_URL

export const sendErrorEmail = async (selected: string, value: string, lastname: string) => {
  try {
    const res = await axios.post(url + '/email/sendMailError', {
      selected: selected,
      value: value,
      lastname: lastname
    })
    return res
  } catch (err) {
    console.log(err)
    return err
  }
}

export const createError = async (trayId: string, message: string, type: string) => {
  try {
    const res = await axios.post(url + '/error/createError', {
      trayId: trayId,
      message: message,
      type: type
    })
    return res.data
  } catch (err) {
    console.log(err)
    return err
  }
}

export const updateError = async (trayId: string) => {
  try {
    const res = await axios.post(url + '/error/updateError', {
      trayId: trayId
    })
    return res.data
  } catch (err) {
    return err
  }
}

export const getPerformanceErr = async (selectedDate: moment.Moment) => {
  try {
    const week = selectedDate.toDate()
    const start = new Date(week.setDate(week.getDate() - week.getDay()))
    const end = new Date(week.setDate(week.getDate() - week.getDay() + 6))

    const res = await axios.get(url + '/error/getPerformance', {
      params: {
        start: start,
        end: end,
      }
    })
    return res.data
  } catch (err) {
    return []
  }
}

export const getErrorsByType = async (selectedFilter, selectedDates: moment.Moment | undefined) => {
  var year
  if (selectedDates) {
    year = selectedDates.toDate().getFullYear()
  } else {
    year = new Date().getFullYear()
  }
  const startDate = new Date(year, 0, 1)
  const endDate = new Date(year, 11, 31)

  try {
    const res = await axios.get(url + '/error/getErrors', {
      params: {
        start: startDate,
        end: endDate,
        types: selectedFilter
      }
    })
    return res.data
  } catch (err) {
    console.log(err)
    return []
  }
}

function getFirstDayOfMonth(year, month) {
  return new Date(year, month, 1);
}

function getLastDayOfMonth(year, month) {
  return new Date(year, month + 1, 0);
}

function convertSecToHoursMinute(second) {
  second = Number(second);
  var h = Math.floor(second / 3600);
  var m = Math.floor(second % 3600 / 60);

  var hDisplay = h > 0 ? h + (h === 1 ? "h" : "h") : "";
  var mDisplay = m > 0 ? m + (m === 1 ? "min" : "min") : "";
  return hDisplay + mDisplay;
}

export const getAverageTime = async (averageDate: moment.Moment) => {
  const date = new Date(averageDate.toDate());
  const firstDayCurrentMonth = getFirstDayOfMonth(
    date.getFullYear(),
    date.getMonth(),
  );

  const lastDayCurrentMonth = getLastDayOfMonth(
    date.getFullYear(),
    date.getMonth(),
  );

  try {
    const res = await axios.get(url + "/error/averageResolveTime", {
      params: {
        start: firstDayCurrentMonth,
        end: lastDayCurrentMonth
      }
    })
    if (res.data) {
      let time = convertSecToHoursMinute(res.data.average)
      return time
    }
  } catch (e) {
    return 0
  }
}

export const dkError = async (photoId: string | null, bpId: string, errorType: string, prediction :any) => {
  try {
    axios.post(url + "/dkError/createError", {photoId: photoId, bpId: Number(bpId), errorType: errorType, prediction: prediction})
  } catch(err) {
    console.log(err)
    return (err)
  }
}